import React, { useEffect, useState } from "react";
import Loading from "../Loading";

const AUTH_STATE = Object.freeze({
  IN_PROGRESS: "IN PROGRESS",
  AUTHORIZED: "AUTHORIZED",
  UNAUTHORIZED: "UNAUTHORIZED",
});

export default function RequireAuth({ children, showUnauthorized = true }) {
  const [authState, setAuthState] = useState(AUTH_STATE.IN_PROGRESS);

  const API_URL = "/api/session";
  const SIGN_IN_URL = "/api/sign-in";

  useEffect(() => {
    const checkSessionValidity = async () => {
      await fetch(API_URL, { credentials: "include", cache: "no-store" })
        .then((res) => {
          [401, 404].includes(res.status)
            ? setAuthState(AUTH_STATE.UNAUTHORIZED)
            : setAuthState(AUTH_STATE.AUTHORIZED);
        })
        .catch(() => setAuthState(AUTH_STATE.UNAUTHORIZED));
    };

    checkSessionValidity();
  }, []);

  useEffect(() => {
    if (authState === AUTH_STATE.UNAUTHORIZED && showUnauthorized) {
      const here = window.location.pathname + window.location.search;
      const url =
        here && here !== "/" ? `${SIGN_IN_URL}?redirect=${encodeURIComponent(here)}` : SIGN_IN_URL;
      window.location.href = url;
    }
  }, [authState, showUnauthorized]);

  const fullPageLoading = (
    <div className="require-auth-loading">
      <Loading />
    </div>
  );

  if (authState === AUTH_STATE.AUTHORIZED) return children;
  if (authState === AUTH_STATE.UNAUTHORIZED) return showUnauthorized ? fullPageLoading : null;

  return showUnauthorized ? fullPageLoading : null;
}
